import { styled, Typography } from '@mui/material'

/**
 * The shell shared by the full-page status screens in `@ui` — `NotFoundPage`
 * and `ForbiddenPage`, which render the same two-column layout around
 * different copy and a different illustration.
 *
 * `@ui/ErrorPage` deliberately does NOT use this: its `Root` takes the
 * viewport height as a prop instead of hardcoding one, and its `Container`
 * adds a gap and a max width. It is a separate, already-reworked layout.
 */

export const Root = styled('div')({
  alignItems: 'center',
  display: 'flex',
  height: 'calc(100vh - 180px)',
})

export const Container = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
    padding: theme.spacing(3),
    width: '100%',
  },
  display: 'grid',
  gridTemplateColumns: '1fr 487px',
  margin: '0 auto',
  width: 830,
}))

export const InnerContainer = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    order: 1,
    textAlign: 'center',
  },
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  justifyContent: 'center',
}))

export const Header = styled(Typography)({
  fontWeight: 600 as const,
})

export const IconContainer = styled('div')({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
})
